import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import NewCalendarGeneralTabs from 'components/tabs-components/create_new_calendar/general';
import PublicHolidays from 'components/tabs-components/create_new_calendar/public_holidays';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import React, { useState } from 'react';
import { Loading } from 'components';

const NewCalendar = () => {
  const [state, setState] = useState({
    finalData: {
      name: '',
      comment: '',
      public_holidays: [
        {
          day: 1,
          month: 1,
          period: 'all_day',
          gender: 'all',
          description: '',
        },
      ],
    },
    activeTab: '1',
  });

  const { finalData, activeTab } = state;
  // console.log(finalData);
  const [errorName, setErrorName] = useState(null);
  const [checkLength, setCheckLength] = useState(false);
  const { createPublicHoliday } = useMember();
  const [loading, setLoading] = useState(false);

  const { successNotification, error } = useNotice();
  const addData = (data: any) => {
    setState((pre) => ({
      ...pre,
      finalData: Object.assign(finalData, data),
    }));
  };
  const handleTabChange = (key) => {
    setState((pre) => ({
      ...pre,
      activeTab: key,
    }));
  };

  const submit = () => {
    setLoading(true);
    setErrorName(null);
    createPublicHoliday(finalData)
      .then((res) => {
        setLoading(false);
        successNotification(
          `"${finalData?.name}" created successfully.`
        );
        setState((pre) => ({
          ...pre,
          finalData: {
            name: '',
            comment: '',
            public_holidays: [
              {
                day: 1,
                month: 1,
                period: 'all_day',
                gender: 'all',
                description: '',
              },
            ],

          },
          activeTab: '1',
        }));
        setCheckLength(false);
      })
      .catch((err) => {
        if (err?.response?.data?.name) {
          error('Missing or incorrect information', '“Name” already exists.', () => setErrorName('error'));
          setState((pre) => ({ ...pre, activeTab: '1', }))

        } else {
          error('Missing or incorrect information', `Field "Description" is required`);
          setState((pre) => ({ ...pre, activeTab: '2', }))
        }
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  };

  if (loading) return <Loading />;
  return (
    <div>
      <GeneralHeader
        pageTitle="New Calendar"
        icon="/icons/new_calendar.svg"
        child={
          <div style={{ marginTop: '65px' }}>
            <div style={{
              justifyContent: 'flex-end',
              display: 'flex',
            }}>
              <button
                disabled={finalData?.name === ''}
                style={{
                  width: 40,
                  height: 40,
                  background: finalData?.name === '' ? '#E4E4E4' : '#407FDD',
                  border: finalData?.name === '' && '0.5px solid #E4E4E4'
                }}
                onClick={() => submit()}
                className="header-button"
              >
                <img src="/icons/save.svg" alt="button" />
              </button>
            </div>

            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={handleTabChange}
              items={[
                {
                  key: '1',
                  label: (
                    <div
                      style={{
                        color: activeTab === '1' ? '#0E3063' : '#757575',
                        fontSize: '20px',
                        fontWeight: 600,
                        margin: '0px 10px'
                      }}
                    >
                      General
                    </div>
                  ),
                  children: <NewCalendarGeneralTabs errorName={errorName} finalData={finalData} addData={addData} />,
                },
                {
                  key: '2',
                  label: (
                    <div
                      style={{
                        color: activeTab === '2' ? '#0E3063' : '#757575',
                        fontSize: '20px',
                        fontWeight: 600,
                        margin: '0px 10px'
                      }}
                    >
                      Public Holidays
                    </div>
                  ),
                  children: (
                    <PublicHolidays checkLength={checkLength} setCheckLength={setCheckLength} finalData={finalData} addData={addData} />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default NewCalendar;
